import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=7d4f34ef&scoped=true"
import script from "./EventPopup.vue?vue&type=script&lang=js"
export * from "./EventPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f34ef",
  null
  
)

export default component.exports